import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import Icon from 'svg-inline-react'
import moment from 'moment'
import { oxford, truncate } from 'humanize-plus'

import { api } from 'app/modules/rules/api'
import DriftAPI from 'components/shared/DriftAPI'
import ACCESS from 'utils/Access'
import OnCallModal from '../OnCallModal'
import OptInModal from '../OptInModal'
import AdvancedRoutingOptInModal from '../AdvancedRoutingOptInModal'
import MappedUsers from 'components/SFDC/containers/MappedUsers'
import TooltipAvatar from 'components/TooltipAvatar'
import TetheredToolTip from 'components/TetheredToolTip'
import IconSVG from 'svg-inline-react'

import { regions } from 'components/settings/Rules/constants/regions'
import { continents } from 'components/settings/Rules/constants/continents'

import { SALES_INBOX_ID, SALES_USER_ID } from 'constants/ResourcesConstants'
import * as CONSTANTS from 'app/modules/rules/constants'

import './style.styl'

import pencilSRC from '!svg-inline?removeTags=true!images/svg/pencil.svg'
import newItemSRC from '!svg-inline?removeTags=true!images/svg/new-item.svg'
import deleteSRC from '!svg-inline?removeTags=true!images/svg/delete.svg'
import rulesScreenShotSRC from '!svg-inline?!images/svg/rules-chat.svg'
import rulesBlankTable from '!svg-inline?!images/svg/rules-blank-table.svg'
import boltIconSrc from '!svg-inline?removeTags=true!images/svg/cql_bolt.svg'

const TOTAL_AVATARS = 4

const reinsert = (arr, from, to) => {
  const _arr = arr.slice(0)
  const val = _arr[from]
  _arr.splice(from, 1)
  _arr.splice(to, 0, val)
  return _arr
}

const clamp = (n, min, max) => {
  return Math.max(Math.min(n, max), min)
}


class RulesHomeLayout extends Component {

  static contextTypes = {
    app: PropTypes.object
  }

  constructor(props) {
    super(props)

    this.state = {
      topDeltaY: 0,
      mouseY: 0,
      moveMouseY: 0,
      isPressed: false,
      originalPosOfLastPressed: 0,
      order: _.range(0),
      count: 0,
      isLoading: props.rulesLoading,
      onCallModalOpen: false,
      optInModalOpen: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rulesLoading !== this.props.rulesLoading) {
      setTimeout(() => {
        this.setState({ isLoading: nextProps.rulesLoading })
      }, 1500)
    }
  }

  componentDidMount() {
    this.fetchRules()
    this.props.actions.fetchOrgUsers()

    window.addEventListener('mousemove', this.handleMouseMove)
    window.addEventListener('mouseup', this.handleMouseUp)
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('mouseup', this.handleMouseUp)
  }

  openOptInModal = () => {
    this.setState({ optInModalOpen: true })
  }

  closeOptInModal = () => {
    this.setState({ optInModalOpen: false })

    this.context.app.actions.NotificationActions.pushNotification({
      content: `You successfully updated your Lead Routing 🎉`,
      variant: 'green',
      displayTime: 1500,
    })
  }

  openAdvancedRoutingOptInModal = () => {
    this.setState({ advancedRoutingOptInModalOpen: true })
  }

  closeAdvancedRoutingOptInModal = () => {
    this.setState({ advancedRoutingOptInModalOpen: false })
  }

  openOnCallModal = () => {
    this.setState({ onCallModalOpen: true })
  }

  closeOnCallModal = () => {
    this.setState({ onCallModalOpen: false })
  }

  handleMouseDown = (pos, pressY, { pageY, target }) => {
    if (target.tagName.toLowerCase() === 'a' || target.tagName.toLowerCase() === 'svg') {return}

    this.setState({
      topDeltaY: pageY - pressY,
      mouseY: pressY,
      moveMouseY: pressY,
      isPressed: true,
      originalPosOfLastPressed: pos,
    })
  }

  handleMouseMove = ({ pageY }) => {
    const {
      isPressed
    } = this.state

    if (isPressed) {
      this.setState({
        moveMouseY: pageY
      })
    }
  }

  handleMouseUp = ({ pageY }) => {
    const { order, originalPosOfLastPressed, isPressed, count, topDeltaY } = this.state
    const rule = this.props.rules[originalPosOfLastPressed]

    if (!isPressed) {return}

    let newOrder = order
    const mouseY = pageY - topDeltaY
    const currentRow = clamp(Math.round(mouseY / 80), 0, count - 1)

    if (currentRow !== order.indexOf(originalPosOfLastPressed)){
      newOrder = reinsert(order, order.indexOf(originalPosOfLastPressed), currentRow)
    }

    if (ACCESS.hasFeature('rules_routing') && isPressed) {
      const ruleIdToUpdate = rule.item.id
      let newCursor = rule.cursor.split('|')

      const ruleForCurrentRow = this.props.rules[currentRow]
      if (!ruleForCurrentRow) {
        console.error(`Unable to update priority, cannot select rule for current row`)
        return        
      }
      
      // new priority becomes priority of the rule for current row
      const newPriority = ruleForCurrentRow.cursor.split('|')[0]

      newCursor[0] = newPriority
      newCursor = newCursor.join('|')

      api.updatePriority(newCursor, ruleIdToUpdate)
    }

    this.setState({
      isPressed: false,
      topDeltaY: 0,
      order: newOrder
    })
  }

  fetchRules = () => {
    api.fetchRules().then(resp => {
      this.setState({
        order: _.range(resp.rules.length),
        count: resp.rules.length
      })

      this.props.actions.fetchRulesSuccess(resp)
    })
  }

  optIn = () => {
    api.optInCentralRouting().then(() => {
      this.openOptInModal()
      this.forceUpdate()
    })
  }

  notifyDelete = (rule) => {
    this.context.app.actions.NotificationActions.pushNotification({
      content: `You successfully deleted a rule`,
      variant: 'gray',
      displayTime: 5000,
      undoAction: () => api.undoDeleteRule(rule.item.id).then(this.fetchRules)
    })
  }

  deleteRule = (rule) => {
    this.setState({
      deletedId: rule.item.id
    }, () => {
      setTimeout(() => {
        api.deleteRule(rule.item.id)
          .then(() => this.notifyDelete(rule))
          .then(this.fetchRules)
      }, 200)
    })
  }

  openChatWidget = (e) => {
    e.preventDefault()
    const chatPayload = {}
    if (SALES_INBOX_ID && SALES_USER_ID) {
      chatPayload.inboxId = SALES_INBOX_ID
      chatPayload.sender = { id: SALES_USER_ID }
    }
    DriftAPI.showWelcomeMessage(chatPayload)
  }

  displayActionType(type) {
    const ACTION_TYPE = {
      [CONSTANTS.ACTION_TYPES.PARTICIPANT]: this.renderParticipantAction,
      [CONSTANTS.ACTION_TYPES.SALESFORCE_PARTICIPANT]: this.renderSalesforceParticipantAction,
      [CONSTANTS.ACTION_TYPES.ABM_PARTICIPANT]: this.renderTargetedAccountsAction,
      [CONSTANTS.ACTION_TYPES.LEANDATA_PARTICIPANT]: this.renderLeandataAction,
    }

    return ACTION_TYPE[type] || (() => <div />)
  }

  displayUrlFilterValue(value) {
    return Array.isArray(value) ? oxford(value, 2, ` and ${value.length - 2} more`) : ''
  }

  displayConditionType(item) {
    if (item.conditions.length === 0 || item.conditions[0].length === 0) {
      return (
        <div>
          <p>Match Always</p>
        </div>
      )
    }
    const { field, value } = item.conditions[0][0]
    const VALUE_RENDER = {
      [CONSTANTS.GEO_FILTER_TYPES.STATE]: CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.GEO_FILTER_TYPES.COUNTRY] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.EMPLOYEES] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MONEY_RAISED] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.COMPANY_CATEGORIES] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MARKET_CATEGORIES] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.TECH_TAGS] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_STATE] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_POSTAL_CODE] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.REVENUE]: CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS]: this.displayVisitsValue(value),
      [CONSTANTS.SALESFORCE_FILTER] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.TARGETED_ACCOUNTS_FILTER] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.LEANDATA_FILTER] : CONSTANTS.CONDITION_SUB_TYPE_LABELS[field],
      [CONSTANTS.URL_FILTER_TYPES.URL_PATH] : this.displayUrlFilterValue(field, value),
      [CONSTANTS.URL_FILTER_TYPES.URL_HOST] : this.displayUrlFilterValue(field, value),
      [CONSTANTS.URL_FILTER_TYPES.URL_QUERY] : this.displayUrlFilterValue(field, value),
    }

    const TOOLTIP_VALUE = {
      [CONSTANTS.GEO_FILTER_TYPES.STATE]: this.displayGeoValue(value),
      [CONSTANTS.GEO_FILTER_TYPES.COUNTRY] : this.displayGeoValue(value),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.EMPLOYEES] : this.displayEmployeeValue(value),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MONEY_RAISED] : this.displayMoneyValue(value),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.COMPANY_CATEGORIES] : this.displayListValues(value),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MARKET_CATEGORIES] : this.displayListValues(value),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.TECH_TAGS] : this.displayListValues(value),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.REVENUE]: this.displayRevenueValue(value),
      [CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS]: this.displayVisitsValue(value),
      [CONSTANTS.URL_FILTER_TYPES.URL_PATH] : this.displayListValues(value),
      [CONSTANTS.URL_FILTER_TYPES.URL_HOST] : this.displayListValues(value),
      [CONSTANTS.URL_FILTER_TYPES.URL_QUERY] : this.displayListValues(value),
    }

    return (
      <div>
        {VALUE_RENDER[field] &&
        <Link to={`/settings/rules/${item.id}`}>
          <span is tooltip={TOOLTIP_VALUE[field]} flow="right">{ VALUE_RENDER[field] }</span>
        </Link>}
        <p>{CONSTANTS.CONDITION_TYPE_LABELS[field]}</p>
      </div>
    )
  }

  displayListValues(value) {
    return Array.isArray(value) ? value.join(', ') : ''
  }

  displayGeoValue(value) {
    const geoBuckets = [...Object.keys(regions), ...Object.keys(continents)]
    const matchedBucket = _.find(geoBuckets, (region) => {
      return _.isEqual(regions[region], value)
    })

    return matchedBucket ? matchedBucket : 'Custom'
  }

  displayRevenueValue(value) {
    return `${value} in annual revenue`
  }

  displayEmployeeValue(value) {
    const matched = _.find(CONSTANTS.EMPLOYEE_NUMBER_GROUPS, (group) => {
      return _.isEqual(group, value)
    })

    return matched ? `${matched.min} - ${matched.max} employees` : 'Custom'
  }

  displayMoneyValue(value) {
    const matched = _.find(CONSTANTS.MONEY_RAISED_GROUPS, (group) => {
      return _.isEqual(group, value)
    })

    return matched ? `$${matched.min} - $${matched.max} million` : 'Custom'
  }


  displayVisitsValue(value) {
    const matched = _.find(CONSTANTS.SITE_VISITS_GROUPS, (group) => {
      return _.isEqual(group, value)
    })

    return matched ? `${matched.min} - ${matched.max} site visits` : 'Custom'
  }

  rowStyle(index) {
    const { originalPosOfLastPressed, order, moveMouseY, isPressed } = this.state
    const rowY = order.indexOf(index) * 80
    const offsetTop = 309
    const isOver = isPressed && ((moveMouseY - offsetTop) > rowY) && ((moveMouseY - offsetTop) < (rowY + 80))

    const style = {
      scale: 1,
      shadow: 0,
      y: rowY,
      x: 0,
      opacity: 1
    }

    const rowStyle = {
      boxShadow: `rgba(0, 0, 0, 0.2) 0px ${style.shadow}px ${2 * style.shadow}px 0px`,
      transform: `translate3d(${style.x}px, ${style.y}px, 0) scale(${style.scale})`,
      zIndex: index === originalPosOfLastPressed ? 99 : index,
      borderTop: isOver ? `2px solid var(--main-blue)` : null,
      opacity: style.opacity
    }

    return { rowStyle, style }

  }

  getAuthorDisplayName(authorId) {
    const { users } = this.props
    const hasBeenUpdated = !!authorId
    const hasAuthor = hasBeenUpdated && !!users[authorId]
    const displayDeletedOrBlank = hasBeenUpdated ? '[Deleted User]' : ''
    const displayAuthor = hasAuthor ? users[authorId].name : displayDeletedOrBlank

    return displayAuthor
  }

  renderOnCallRow() {
    const { users, onCall } = this.props
    const author = this.getAuthorDisplayName(onCall.lastUpdatedBy)
    return (
      <div className={`rule-row`}>

        <div className="rule-drag-wrap" >
          <div className="rule-drag-handle">

          </div>
        </div>

        <div className="rule-priority-wrap"><div>
          <span className="rule-priority"></span>
        </div></div>

        <div className="rule-title-wrap"><div className="rule-title">
          <span className="rule-title-link" onClick={this.openOnCallModal}>Default Rule</span>
          <p>last edited by <span>{author && truncate(author, 15) }</span></p>
        </div></div>

        <div><div className="rule-condition">
          <div>
            <span className="rules-oncall-condition-title">Drift Routing</span>
            <p>Default Rule</p>
          </div>
        </div></div>

        <div><div className="rule-participants">
          <div className="rule-participants-avatars-list">
            {onCall.userIds && onCall.userIds.map((id, index)=> {
              if (index === TOTAL_AVATARS) {return <span className="rule-participants-more" key={id}>+ {onCall.userIds.length - TOTAL_AVATARS} more</span>}
              if (index > TOTAL_AVATARS) {return null}
              return <TooltipAvatar key={id} tooltipName={users[id].name} user={users[id]} />
            })}
            {!onCall.userIds.length && <span className="rules-no-participants"></span>}
          </div>
          <p>Add Participant</p>
        </div></div>

        <div><div className="rules-actions">
          <span onClick={this.openOnCallModal}><Icon src={pencilSRC} /></span>
        </div></div>

      </div>
    )
  }

  renderDisabledRow(opts = { upgrade: true, priority: 1, title: "USA Territory", filter: { title: "Country", subtitle: "Geolocation" }}) {
    const hasAccess = ACCESS.hasFeature('rules_routing')

    return (
      <div className="rule-row disabled-rule-row">

        <div className="rule-drag-wrap" >
          <div className="rule-drag-handle">

          </div>
        </div>

        <div className="rule-priority-wrap"><div>
          <span className="rule-priority">{opts.priority}</span>
        </div></div>

        <div className="rule-title-wrap"><div className="rule-title">
          <Link to={''}>{opts.title}</Link>
            <p>last edited by <span></span></p>
        </div></div>

        <div><div className="rule-condition">
          <div>
            <span className="rules-oncall-condition-title">{opts.filter.title}</span>
            <p>{opts.filter.subtitle}</p>
          </div>
        </div></div>

        <div><div className="rule-participants">
          <div className="rule-participants-avatars-list">
            <span className="rules-no-participants"></span>
          </div>
          <p>Add Participant</p>
        </div></div>

        <div><div className="rules-actions">

        </div></div>
        {opts.upgrade && !hasAccess && <span className="upgrade-ribbon">Upgrade</span>}
      </div>
    )
  }

  renderTableHeader() {
    return (
      <div className="rules-table-header">
        <div className={`rule-row`}>

          <div className="rule-drag-wrap" >
            <div>
              <strong className="rules-table-header-cell">ORDER</strong>
            </div>
          </div>

          <div className="rule-priority-wrap"><div>
            <span className="rule-priority"></span>
          </div></div>

          <div className="rule-title-wrap"><div className="rule-title">
            <strong className="rules-table-header-cell">NAME</strong>
          </div></div>

          <div><div className="rule-condition">
            <strong className="rules-table-header-cell">RULE</strong>
          </div></div>

          <div><div className="rule-participants">
            <strong className="rules-table-header-cell">ACTION</strong>
          </div></div>

          <div><div className="rules-actions">

          </div></div>
        </div>
      </div>
    )
  }

  renderTableRows() {
    const { order, deletedId } = this.state

    return this.props.rules.map((rule, i) => this.renderRow(rule, i, deletedId, order))
  }

  renderRow(rule, i, deletedId, order) {
    const {
      isPressed,
      moveMouseY
    } = this.state
    const style = this.rowStyle(i)
    const draggedOver = isPressed ? 'rule-row-dragged-over' : ''
    const willRemove = rule.item.id === deletedId ? 'will-remove-row' : ''
    const author = this.getAuthorDisplayName(rule.item.authorId)
    const priority = order.indexOf(i) + 1

    return (
      <div
        className={`rule-row ${ willRemove } ${ draggedOver }`}
        style={ style.rowStyle }
        key={rule.item.id}
        >

        <div className="rule-drag-wrap" onMouseDown={this.handleMouseDown.bind(null, i, style.style.y)}>
          <div className="rule-drag-handle">
            <p>...</p>
            <p>...</p>
          </div>
        </div>

        <div className="rule-priority-wrap"><div>
          <span className="rule-priority">{priority || '#'}</span>
        </div></div>

        <div className="rule-title-wrap"><div className="rule-title">
        <TetheredToolTip
          className="rule-title-tooltip"
          flow="up"
          component={rule.item.name}
          disabled={rule.item.name.length <= 31}>
          <Link href={`/settings2/rules/${rule.item.id}/edit`}>{rule.item.name}</Link>
        </TetheredToolTip>
          <p>last edited by <span>{author && truncate(author, 15)} {moment(rule.item.updatedAt).format('MM/DD/YYYY')}</span></p>
        </div></div>

        <div><div className="rule-condition">
          {this.displayConditionType(rule.item)}
        </div></div>

        <div><div className="rule-participants">
          {this.displayActionType(rule.item.action.type)(rule.item.action)}
        </div></div>

        <div><div className="rules-actions">
           <Link href={`/settings2/rules/${rule.item.id}/edit`}><Icon src={pencilSRC}/></Link>
          <Icon src={deleteSRC} onClick={() => this.deleteRule(rule)}/>
        </div></div>
      </div>
    )

  }

  renderParticipantAction = (action) => {
    const { users, teams } = this.props
    const hasUserIds = !!action.options.userIds && action.options.userIds.length > 0 
    const userIdsToRender = hasUserIds ? action.options.userIds.slice(0, TOTAL_AVATARS) : []
    const team = action.options.teamId && teams.find(x => x.id === action.options.teamId)
    return (
      <div>
        { action.options.teamId && team &&
          <div className="flex">
            <TooltipAvatar type="team" flow="up" tooltipName={team.name} team={team}/>
          </div>
        }
        { hasUserIds &&
          <div className="rule-participants-avatars-list">
            { userIdsToRender.map((id) => <TooltipAvatar key={id} tooltipName={users[id].name} type="user" user={users[id]} />)
            }
            { action.options.userIds.length - TOTAL_AVATARS > 0 &&
              <span className="rule-participants-more">+ {action.options.userIds.length - TOTAL_AVATARS} more</span>
            }
          </div>
        }
        <p>Add Participant</p>
      </div>
    )
  }

  renderLeandataAction = () => {
    return (
      <div>
        <div className="rule-participants-avatars">
          <TooltipAvatar key="LeanData Owner" tooltipName={"LeanData Owner"} type="user"/>
        </div>
        <p>Add LeanData Owner</p>
      </div>
    )
  }

  renderTargetedAccountsAction = () => {
    return (
      <div>
        <div className="rule-participants-avatars">
          <TooltipAvatar key="ABM" tooltipName={"ABM"} type="user"/>
        </div>
        <p>Add Drift Account Owner</p>
      </div>
    )
  }

  renderSalesforceParticipantAction = () => {
    const { users } = this.props
    return (
      <div>
        <div className="rule-participants-avatars-list">
          <MappedUsers users={users} max={TOTAL_AVATARS}/>
        </div>
        <p>Add Salesforce Participant</p>
      </div>
    )
  }

  renderUpsell() {
    return (
      <div className="routing-rules">
        <div className="rules-gate">
          <div className="rules-gated-content">
            <h2>Want to 10x your Lead Routing?</h2>
            <p>
              Use smart lead routing to get anonymous leads to the right person on your team based on filters such as their location, company size, URL and more.
            </p>
            <button className="drift-button drift-button-primary large" onClick={this.openChatWidget}>Upgrade</button>
            <a className="drift-button large" target="_blank" href="//help.drift.com/setup/rules">Learn More</a>
          </div>
          <Icon src={ rulesScreenShotSRC } />
        </div>
      </div>

    )
  }

  renderLoading() {
    return (
      <div className="routing-rules loading">
        <header>
          <p>
            Use smart lead routing to route anonymous leads to the right person on your team based on filters such as their location, company size, URL and more.<br />
            <a target="_blank" href="//help.drift.com/setup/rules">Learn More</a>
          </p>
        </header>

        <section className="routing-rule-table">
            <Icon src={rulesBlankTable} />
        </section>
      </div>
    )
  }

  optIntoAdvancedRouting = () => {
    this.props.actions.patchOrgProperties([
      {
        operation: 'set',
        property: 'advancedRoutingOptIn',
        value: true,
      },
    ])
  }

  renderAdvancedRoutingOptIn() {
    return (
      <div className="advanced-routing-opt-in-container">
        <div className="advanced-routing-opt-in-fake-border"></div>
        <div className="advanced-routing-opt-in">
          <div>
            <div className="advanced-routing-opt-in-new-badge">
            <IconSVG className="advanced-routing-opt-in-new-bolt" src={boltIconSrc} />
            NEW!
            </div>
            <h4 className="advanced-routing-header">A more powerful way to set up routing rules</h4>
            <div className="advanced-routing-opt-in-content">
              <p>
              Drift’s new Advanced Routing allows you to create powerful routing rules to support your organization. Branch based on conditions, set up fallbacks, and more!
              <a target="_blank" href="https://gethelp.drift.com/hc/en-us/articles/360024875354-How-to-Use-Advanced-Routing"> Learn More</a>
              </p>
            </div>
          </div>
          <div>
            <button className="drift-button medium advanced-routing-opt-in-button" onClick={this.openAdvancedRoutingOptInModal}>Try it out!</button>
          </div>
        </div>
      </div>
    )
  }

  renderOptIn() {

    return (
      <div className="opt-in-module">
        <h2>Just a heads up on a product change coming up 👋</h2>
        <div className="opt-in-module-content">
          <p>
          On-Call status is becoming the Default Lead Routing Rule so you have more control over who is automatically added to a conversation. Update your Default Lead Routing Rule to add teammates to conversations on a round-robin basis.
          <a target="_blank" href="//help.drift.com/settings/changes-to-on-call"> Learn More</a>
          </p>
          <div>
            <button className="drift-button-primary drift-button large" onClick={this.optIn}>Update</button>
            <small>Got questions? <a href="" onClick={this.openChatWidget}>Talk to us! 🙂</a></small>
          </div>
        </div>
      </div>
    )
  }

  renderPageHeader() {
    const hasAccess = ACCESS.hasFeature('rules_routing')
    const hasCentralizedRouting = ACCESS.hasGates('CENTRALIZED_ROUTING')
    const hasOptInAccess = ACCESS.hasGates('ROUTING_OPT_IN')
    const description = hasAccess ?
      () => (
        <div>
          <p>
            Use rules to route anonymous leads to the right person on your team based on filters such as their location, company size, URL and more.
          </p>
          <p>
          * Please note: Routing rules in playbooks take precedence over Conversation Routing rules. 
            <a target="_blank" href="//help.drift.com/setup/rules"> Learn More</a>
          </p>
        </div>
      ) :
      () => (
        <p>
          Use Rules to automatically add participants to conversations and make sure no lead goes unanswered. Just add your teammembers to these rules, and your Drift chats will be directed to them.
        </p>
      )

    const newRuleButton =
      <Link
        href="/settings2/rules/new"
        className="new-rule-button drift-button drift-button-primary">
        <Icon src={newItemSRC} />
        Create New Rule
      </Link>

    return (
      <div>
        {
          this.props.hasVisualRoutingBuilder
          && this.renderAdvancedRoutingOptIn()
        }
        {!hasCentralizedRouting && hasOptInAccess && this.renderOptIn()}
        <header className={!hasAccess && 'no-access'}>
          {hasAccess && newRuleButton}
          {description()}
        </header>
      </div>
    )
  }

  renderBottomSection() {
    const hasAccess = ACCESS.hasFeature('rules_routing')

    if (!hasAccess) {return this.renderUpsell()}
    if (this.props.rules.length) {return null}

    const newRuleButton =
      <Link
        href="/settings2/rules/new"
        className="new-rule-button drift-button drift-button-primary">
        <Icon src={newItemSRC} />
        Create New Rule
      </Link>
    
    return (
      <div className="rules-empty-table-state">
        <h2>You don’t have any supercharged rules yet!</h2>
        <p>Create your first rule based on filters like geolocation, URL and company information.</p>
        {newRuleButton}
      </div>
    )
  }

  renderFloatingRow() {
    const {
      isPressed,
      moveMouseY,
      originalPosOfLastPressed,
    } = this.state

    if (!isPressed) {return null}

    const rule = this.props.rules[originalPosOfLastPressed]
    const style = {
      scale: 1,
      shadow: 0,
      x: 0,
      opacity: 1
    }

    const rowStyle = {
      boxShadow: `rgba(0, 0, 0, 0.2) 0px ${style.shadow}px ${2 * style.shadow}px 0px`,
      transform: `translate3d(${style.x}px, ${style.y}px, 0) scale(${style.scale})`,
      opacity: style.opacity
    }
    const author = this.getAuthorDisplayName(rule.item.authorId)
    const dragStyle = {
      position: 'absolute',
      background: '#fff',
      paddingLeft: '60px',
      border: '1px solid var(--main-navy-extra-light)',
      borderRadius: '3px',
      boxShadow: `rgba(0, 0, 0, 0.2) 0px 5px 5px 0px`,
      width: '725px',
      opacity: 0.8,
      top: moveMouseY,
      zIndex: 200
    }

    return (
      <div
        style={dragStyle}
        className="routing-rule-row--dragging"
      >
        { rule.name }
        <div
          className="rule-row"
          style={ rowStyle }
          key={rule.item.id}
          >

          <div className="rule-title-wrap"><div className="rule-title">
            <Link to={`/settings/rules/${rule.item.id}`}>{rule.item.name}</Link>
            <p>last edited by <span>{author && truncate(author, 15)} {moment(rule.item.updatedAt).format('MM/DD/YYYY')}</span></p>
          </div></div>

          <div><div className="rule-condition">
            {this.displayConditionType(rule.item)}
          </div></div>
        </div>
      </div>
    )
  }

  render() {
    const { isLoading } = this.state
    const { rules, onCall, users } = this.props
    const onCallRuleTop = rules.length ? `${(rules.length * 80)}px` : '80px'
    const hasCentralizedRouting = ACCESS.hasGates('CENTRALIZED_ROUTING')
    const hasOptInAccess = ACCESS.hasGates('ROUTING_OPT_IN')
    const onCallDisabledOpts = {
      upgrade: false,
      priority: '',
      title: 'Default Rule',
      filter: {
        title: 'Drift Routing',
        subtitle: 'Default Rule'
      }
    }
    return (
      <div className={`routing-rules ${isLoading && 'loading'}`}>
        {this.renderPageHeader()}

        { this.renderTableHeader() }

        <section className="routing-rule-table">
          { isLoading && <Icon src={rulesBlankTable} /> }
          { !isLoading && !rules.length && this.renderDisabledRow() }
          { !isLoading && this.renderTableRows() }
        </section>

        {this.renderFloatingRow()}

        {!isLoading && hasOptInAccess &&
          <section className="routing-rule-table" style={ { top: onCallRuleTop } }>
            { hasCentralizedRouting ? this.renderOnCallRow() : this.renderDisabledRow(onCallDisabledOpts)}
          </section>
        }

        {this.renderBottomSection()}

        {this.state.onCallModalOpen &&
          <OnCallModal onClose={this.closeOnCallModal} fetchRules={this.fetchRules} onCall={onCall} users={users} />
        }

        {this.state.optInModalOpen &&
          <OptInModal onClose={this.closeOptInModal} />
        }

        {this.state.advancedRoutingOptInModalOpen &&
          <AdvancedRoutingOptInModal onClose={this.closeAdvancedRoutingOptInModal} optIntoAdvancedRouting={this.optIntoAdvancedRouting} /> 
        }
      </div>
    )
  }
}

export default RulesHomeLayout



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/layouts/RulesHome/index.js